import { connect } from 'react-redux'
import { createService, updateService, updateServiceGroupRideRadius } from '../../state/actions/services/index'
import { getService } from '../../state/reducers/services'
import {
  IServiceCreateObject,
  IServiceGroupRideRadiusUpdate,
  IServiceUpdateObject,
  IStoreState
} from '../../types/index'
import { fetchServicePrograms } from '../../state/actions/service-program/service-program'
import { getAllServicePrograms, getServiceProgram } from '../../state/reducers/service-program/service-program'
import ServiceEditGroupRideSettings from 'src/components/services/edit/ServiceEditGroupRideSettings'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = ownProps.serviceId ? ownProps.serviceId : state.service.metadata.edit.serviceId
  const service = getService(state, serviceId)
  let groupRideInfo = null
  if (service) {
    groupRideInfo = {
      ondemandGridePickupRadius: service.ondemandGridePickupRadius,
      ondemandGrideDropoffRadius: service.ondemandGrideDropoffRadius,
      scheduledGridePickupRadius: service.scheduledGridePickupRadius,
      scheduledGrideDropoffRadius: service.scheduledGrideDropoffRadius,
      scheduledGridePickupTime: service.scheduledGridePickupTime,
      scheduledGrideDropoffTime: service.scheduledGrideDropoffTime,
      allowGroupingDifferentProducts: service.allowGroupingDifferentProducts
    }
  }
  return {
    formRef: ownProps.formRef,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted,
    onCreateServiceCompleted: ownProps.onCreateServiceCompleted,
    serviceId,
    groupRideInfo
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    onComponentMount: () => {
      dispatch(fetchServicePrograms())
    },
    onComponentSubmit: (service: IServiceGroupRideRadiusUpdate) => {
      if (service.hasOwnProperty('id')) {
        return dispatch(updateServiceGroupRideRadius(service as IServiceGroupRideRadiusUpdate))
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditGroupRideSettings)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditGroupRideSettings.ts